import React from 'react';
import './TemplateSelectionDialogueIn2D.scss';

const templateSelectionDialogueIn2D = props => {
  const { templates, clickHandler, activeIndex } = props;

  return (
    <div className='templateListContainer'>
      {templates.map((template, index) => (
        <div className='templatePreview' key={template.previewImageUrl}>
          <button
            type='button'
            className={`circledButton${
              activeIndex == index ? ' selectedCircledButton' : ''
            }`}
            onClick={() => {
              clickHandler(index);
            }}
          >
            <img
              className='templateImage'
              src={template.previewImageUrl}
              alt='template_preview'
            />
          </button>
        </div>
      ))}
    </div>
  );
};

export default templateSelectionDialogueIn2D;
